import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import SearchButton from '../search-button';
import style from './style.css';

class SearchTypes extends Component {
  state = {
    selectedType: null
  };

  selectType = type => {
    this.setState(previousState => {
      return {
        ...previousState,
        selectedType: type
      };
    });
    this.props.handleClick(type);
  };

  buttonIsActive = id => {
    return this.state.selectedType === id;
  };

  componentDidMount() {
    this.setState(previousState => ({
      ...previousState,
      selectedType: null
    }));
  }

  componentWillReceiveProps(nextProps) {
    // Always reset selected when db changes
    this.setState({selectedType: null});
  }


  render({ types, ...props }) {
    return (
      <div class={style['search-buttons']}>
        {types.map((type, index) => {
          const {id} = type;
          return (
            <SearchButton
              class={style['search-types--home']}
              key={index}
              {...type}
              isActive={type.selected || this.buttonIsActive(id)}
              handleClick={this.selectType}
            />
          );
        })}
      </div>
    );
  }
}

SearchTypes.propTypes = {
  types: PropTypes.array.isRequired
};

export default SearchTypes;
